import { render, staticRenderFns } from "./Pavilions.vue?vue&type=template&id=d5baeac2&scoped=true&"
import script from "./Pavilions.vue?vue&type=script&lang=js&"
export * from "./Pavilions.vue?vue&type=script&lang=js&"
import style0 from "./Pavilions.vue?vue&type=style&index=0&id=d5baeac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5baeac2",
  null
  
)

export default component.exports